<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月24日 11:23:26
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="nursing">
        <transition name="tabs">
          <tabs v-if="!isFlatThreeFullScreen" :tabs="tabs"></tabs>
        </transition>
        <div v-loading.fullscreen.lock="filterscreenLoading">
          <router-view :key="key"></router-view>
        </div>
    </div>
</template>

<script>
import { mapState,mapGetters} from 'vuex'
import tabs from '@/common/tabs.vue'
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
      tabs,

  },
  // 组件状态值
  data () {
   return {
      tabs:[
      {
        path:"nursingOne",
        name:"单个执行",
        show:true
      },
      {
        path:"nursingBatch",
        name:"批量执行",
        show:!this.$store.state.isScanCode
      },
      {
        path:"nursingHistory",
        name:"历史记录",
        show:true,
      },
    ]
   }
  },
  // 计算属性
  computed: {
    ...mapState(['filterscreenLoading']),
    ...mapGetters(['isFlatThreeFullScreen']),
    key() {
      return this.$route.path+this.$route.query.Id
    }

  },
  // 侦听器
  watch: {


  },
  // 组件方法
  methods: {


  },

}
</script>

<style scoped>
.nursing {

}
</style>



// WEBPACK FOOTER //
// src/components/nursing/index.vue